var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79.375mm",
    height: "21.167mm",
    viewBox: "0 0 79.375 21.166666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.23 -112.55)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 320.82 250.25)",
    fillRule: "evenodd",
    stroke: "#b8b81a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -678.54,
    y: -516.45,
    width: 292,
    height: 72,
    rx: 10,
    ry: 30,
    fill: "#ebedcb",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: -669.09,
    y: -506.96,
    width: 273.11,
    height: 53.035,
    rx: 10,
    ry: 30,
    fill: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.f466a2facc1294ed6c734f3b7f40864e.svg";
export { ForwardRef as ReactComponent };